import type { ConsentKitApi, UserConfig } from "./types";
import { ConsentKit } from "./consent-kit";

declare global {
  interface Window {
    ConsentKit?: ConsentKitApi;
    consentKitConfig?: UserConfig;
  }
}

/**
 * Self-booting entry for the drop-in build. Everything happens at evaluation time —
 * no DOMContentLoaded wait — because a guard installed after the page has parsed is a
 * guard that let the first tracker through.
 *
 * `document.currentScript` is only valid while the script is executing, so it is read
 * immediately rather than inside the constructor.
 */
const script = document.currentScript as HTMLScriptElement | null;

if (window.ConsentKit) {
  console.warn("[consentkit] already initialised — the script tag is on the page twice.");
} else {
  window.ConsentKit = new ConsentKit(script, window.consentKitConfig);
}
